
import { MatPaginatorIntlPTBR } from "./shared/utils/mat-paginator-intl-pt-br";
import { BrowserModule } from "@angular/platform-browser";
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule, APP_INITIALIZER, Injector } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { Router } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSidenavModule } from "@angular/material/sidenav";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { JwtModule, JWT_OPTIONS } from "@auth0/angular-jwt";
import { NgxMaskOptions, provideNgxMask } from "ngx-mask";
import { NgxCurrencyDirective, NgxCurrencyInputMode, provideEnvironmentNgxCurrency } from "ngx-currency";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";

import { registerLocaleData } from '@angular/common';
import localeBr from '@angular/common/locales/pt';
import { MonacoEditorModule } from "ngx-monaco-editor-v2";
import { ApplicationQueryParamsInterceptor, AuthService, ConfigService, ErrorInterceptor, GlobalVariablesService, AuthGuard, AuthTokenInterceptor, LoadingInterceptor, SpinnerComponent, HeaderComponent, SidemenuComponent } from "@i7/shared";
import { environment } from '../environments/environment';
import { OVERLAY_DEFAULT_CONFIG } from "@angular/cdk/overlay";
import { providePrimeNG } from "primeng/config";
import Aura from '@primeuix/themes/aura';
import { AuthSemMenuGuard } from "./guards/auth-sem-menu.guard";
import { ScrollNavigationComponent } from "./shared/components/scroll-navigation/scroll-navigation.component";

registerLocaleData(localeBr, 'pt')

export function jwtOptionsFactory() {
  return {
    tokenGetter: () => {
      const tokenResponse = JSON.parse(window.localStorage.getItem("auth") as string);
      if (tokenResponse) {
        return tokenResponse.token;
      }
    },
    whitelistedDomains: ["localhost:8080", "{PROD_ENV}"],
  };
}

export const options: Partial<NgxMaskOptions> = {
  decimalMarker: ",",
  validation: false,
  showMaskTyped: true,
};

export const CustomCurrencyMaskConfig = {
  align: "left",
  allowNegative: false,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
  inputMode: NgxCurrencyInputMode.Natural,
  allowZero: true,
  nullable: false

};

export function tokenGetter() {
  return localStorage.getItem("jwt_token");
}

export const MY_DATE_FORMAT = {
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export function initializeApp(configService: ConfigService, injector: Injector) {
  return async () => {
    await configService.load(environment);
    const authService = injector.get(AuthService);

    if (ConfigService.hasStartupError()) {
      authService.invalidateSession();
      await injector.get(Router).navigate(["/public/sign-in"]);
      return;
    }

    authService.initialize();
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    /*StorageServiceModule, -- Verificar*/
    MatSidenavModule,
    HttpClientModule,
    JwtModule.forRoot({
        jwtOptionsProvider: {
            provide: JWT_OPTIONS,
            useFactory: jwtOptionsFactory,
        },
    }),
    NgxCurrencyDirective,
    MonacoEditorModule.forRoot(),
    SpinnerComponent,
    HeaderComponent,
    SidemenuComponent,
    ScrollNavigationComponent
],
  providers: [
    AuthSemMenuGuard,
    GlobalVariablesService,
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlPTBR },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApplicationQueryParamsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: "pt-BR" },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide:OVERLAY_DEFAULT_CONFIG, useValue: {usePopover: false}},
    provideEnvironmentNgxCurrency(CustomCurrencyMaskConfig),
    providePrimeNG({
          theme: { preset: Aura, options: { darkModeSelector: '.p-dark' } },
      }),

    ConfigService,
    // Garante que o ConfigService carregue antes da app iniciar
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService, Injector],
      multi: true
    },
    provideNgxMask() 

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
